import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, useAppSelector } from "../redux/AppStore";
import {
  DownloadPodThunk, EtaForTrackingThunk, resetdriverInfo, resetImages, resetPodData, resetPostcode,
  resetTrackingNum, setEtaDetailsLoaded, setTrackingNum, setUserPostCode, ShipmentTrackingActionThunk
} from "../redux/slice/TrackingSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { resetstatus, UserVerifyFromPostCodeThunk } from "../redux/slice/UpdateTrackingAddressSlice";
import { Button } from "primereact/button";
import DriverLocationComponent from "./DriverLocationDialog";
import ShipmentTrackingApi from "../api/ShipmentTrackingApi";
import { podFatherHost, browserTimeZone } from "./trackingSettings";
export default function OrderDetailsComponent() {
  const dispatch = useDispatch<AppDispatch>();
  const EtaDetails = useSelector((state: RootState) => state.tracking.etaData);
  const companyInfo = useSelector((state: RootState) => state.tracking.companyinfo);
  const navigate = useNavigate();
  const loc = useLocation();
  const trackingNumber = useAppSelector((state: RootState) => state.tracking.trackingNum);
  const postCode = useAppSelector((state: RootState) => state.tracking.userPostCode);
  const shipmentType = useAppSelector((state: RootState) => state.tracking.shipmentType);
  const [isReadOnly, setIsReadOnly] = useState<boolean>(false);
  // useEffect(() => {
  //   if ((trackingNumber === null || trackingNumber === '') && loc.pathname !== '/') {
  //     navigate('/');
  //   }
  // }, [trackingNumber]);
  const [status, setStatus] = useState<string[]>([]);
  const userPostcode = useSelector((state: RootState) => state.tracking.userPostCode);
  const trackingdata = useAppSelector((state: RootState) => state.tracking.trackingdata);
  const shipmentStatus = useAppSelector((state: RootState) => state.updateAddress.status);
  const isEtaLoaded = useAppSelector((state: RootState) => state.tracking.etaDetailsLoaded);
  const driverLcation = useAppSelector((state: RootState) => state.tracking.driverlocation);
  const [cstatus, setCStatus] = useState('');
  const [loadIdentity, setloadIdentity] = useState('');
  const [code, setCode] = useState('');
  const [postcodes, setpostcodes] = useState('');
  const trackingStatus = useSelector((state: RootState) => state.tracking.trackingstatus);
  const fullAccess = useAppSelector((state: RootState) => state.tracking.fullAccess);
  const isInternal = useAppSelector((state: RootState) => state.tracking.isinternal);
  const hasToken = Boolean(new URLSearchParams(loc.search).get("token"));
  // BR-1929: Fragilistics POD found in PODFather for a number our system does not know (old-page parity).
  const [podFatherPod, setPodFatherPod] = useState<{ jobid: string, path: string } | null>(null);
  useEffect(() => {
    setStatus(Object.keys(trackingdata));
  }, [trackingdata]);

  useEffect(() => {
    for (let v of status) {
      for (let d of trackingdata[v]) {
        setCStatus(d.code_text);
        setloadIdentity(d.load_identity);
        setCode(d.code);
        setpostcodes(d.shp_postcode);
        break;
      }
      break;
    }

  }, [status])

  useEffect(() => {
    if (isEtaLoaded) {
      formatEtaData();
    }
  }, [isEtaLoaded]);
  // Only run TrackingData on explicit Track button click.

  const TrackingData = async () => {
    if (!trackingNumber || String(trackingNumber).trim() === '') {
      return;
    }
    dispatch(resetImages());
    dispatch(resetPodData());
    dispatch(resetdriverInfo());
    setPodFatherPod(null);

    // BR-1881: send the typed postcode / phone digits WITH the tracking call — the API now returns the address,
    // POD and driver details only when they match the shipment (otherwise status and events only).
    const verifier = String(userPostcode || '').trim();
    const actionResult = await dispatch(
      ShipmentTrackingActionThunk({
        identity: trackingNumber,
        origin: "tracking",
        filtertype: "st",
        ...(verifier !== '' ? { postcode: verifier, mobileNo: verifier } : {})
      }),
    );
    const payload = (actionResult as any)?.payload;
    if (payload?.status !== 'success') {
      // The slice alerts every other failure; "not recognised" (ERROR003) is left to this handler.
      if (payload?.message && payload?.error_code === 'ERROR003') {
        // BR-1929: on the Fragilistics site a number we do not know may be a PODFather job — ask before alerting.
        if (podFatherHost()) {
          const jobid = String(trackingNumber).trim();
          const pod = await new ShipmentTrackingApi().EPodFather(jobid).catch(() => null);
          if (pod?.status === 'true' && /^https:\/\//i.test(String(pod?.pod_path || ''))) {
            setPodFatherPod({ jobid, path: String(pod.pod_path) });
            return;
          }
        }
        // BR-1920: since BR-1881 an order number alone is not enough — say what to add.
        alert(verifier !== '' ? payload.message
          : `${payload.message}\n\nIf this is your order number, enter your delivery postcode as well and press Track again.`);
      }
      return;
    }
    if (trackingNumber !== '') {
      navigate('/track');
    }
    // BR-1920: the reply itself says whether it is the full record (restricted !== true). Read the delivery
    // postcode from THIS reply — the store still holds the previous search at this point.
    if (payload.restricted === true) {
      return;
    }
    const addresses = Array.isArray(payload.tracking_info?.tracking_address) ? payload.tracking_info.tracking_address : [];
    const deliveryLeg = addresses.find((t: any) => (t.load_identity == trackingNumber || t.shipment_ticket == trackingNumber)
      && t.shipment_service_type == 'D') || addresses.find((t: any) => t.shipment_service_type == 'D');
    const deliveryPostcode = String(deliveryLeg?.post_code || verifier);
    // A retailer order number resolves to one load (BR-1881). Carry on with the load's own number: the verify
    // call and the photo / address matching further down only know load and ticket numbers.
    const resolvedIdentity = String(deliveryLeg?.load_identity || trackingNumber).trim();
    if (deliveryLeg && deliveryLeg.load_identity != trackingNumber && deliveryLeg.shipment_ticket != trackingNumber) {
      dispatch(setTrackingNum(resolvedIdentity));
    }
    if (verifier !== '') {
      dispatch(
        UserVerifyFromPostCodeThunk({
          trackingNo: resolvedIdentity,
          postCode: verifier,
          mobileNo: verifier,
          verifyfrom: "D",
          verifStatus: "5fe69c95ed70a9869d9f9af7d8400a6673bb9ce9"
        }),
      )
    }
    if (deliveryPostcode !== '') {
      dispatch(
        DownloadPodThunk({
          identity: resolvedIdentity,
          delivery_postcode: deliveryPostcode,
          origin: "tracking",
          tracking_type: "pod",
          pod_origin: "",
          endPointUrl: "/searchDeliveryAddress",
          timezone_name: browserTimeZone()
        })
      )
    }
  }
  const formatEtaData = () => {
    dispatch(
      EtaForTrackingThunk({
        identity: trackingNumber,
        origin: "tracking",
        filtertype: "st",
        company_id: String(companyInfo?.company_id ?? ''),
        job_type: String(shipmentType),
        etadetails: EtaDetails,
        endPointUrl: "/getEtaInfoTracking",
        timezone_name: browserTimeZone()
      }),
    );
    dispatch(setEtaDetailsLoaded(false));
  }
  const tracks = () => {
    dispatch(resetstatus());
    dispatch(resetTrackingNum());
    dispatch(resetPostcode());
    dispatch(resetImages());
    navigate('/');
  }

  const statusInfo: any = {
    "Booking Confirmed": "Booked",
    "Collected": "Picked Up",
    "Loaded On Van": "Loaded",
    "Return": "Returned",
    "Partly Collected": "Partly Collected",
    "Partly Delivered": "Partly Delivered",
    "In Transit": "In Transit",
    "Scanned In Warehouse": "In Warehouse",
    "Carded-In Warehouse": "In Warehouse",
    "Collection Attempted": "Carded",
    "Cancelled": "Cancelled",
    "Awaiting Collection": "Booked",
    "Awaiting Required": "Booked",
    "At Delivery Location": "At Delivery Location",
    "Delayed": "Delayed",
    "Delivery On Hold": "Delivery On Hold",
    "Late Delivery": "Late Delivery",
    "Rescheduled": "Rescheduled",
    "Returned By Controller": "Returned",
    "Collection On Hold": "Booked",
    "collection Carded By Controller": "Attempted",
    "Collection Carded": "Carded",
    "Delivered": "Delivered",
    "Out For Delivery": "Out For Delivery",
    "Delivery Carded By Controller": "Attempted",
    "Delivery Return": "Returned",
    "Delivery Attempted": "Attempted",
    "Received in Warehouse by Controller": "In Warehouse",
    "RETURN_IN_WAREHOUSE": "In Warehouse",
    "Returned In Warehouse": "In Warehouse",
  };

  let getMappingMessage = statusInfo[cstatus];
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const openDialog = () => {
    setIsDialogOpen(true);
  };
  const closeDialog = () => {
    setIsDialogOpen(false);
  };
  const location = () => {
    openDialog();
  }
  const [driverlat, setdriverlat] = useState('');
  const [driverlong, setdriverlong] = useState('');

  useEffect(() => {
    for (let d of driverLcation) {
      if (d.driver_location.length != 0) {
        setdriverlat(d.driver_location.latitude);
        setdriverlong(d.driver_location.longitude);
      }
    }
  }, [driverLcation])

  return (
    <>
      <div className="min_containerAll">
        <div className="Sub_navbrand">
          <div className="container max-width_controll">
            <div className="topSub_columns">
              <div className="Sub_left_columns mobile_hide">
                <span className="text_color_black">ORDER</span>
                {cstatus == '' &&
                  <span className="text_color_green">DETAIL</span>
                }
                {
                  <span className="text_color_green">{getMappingMessage}</span>
                  // :    
                  // <span className="text_color_green">{cstatus}</span> 

                }
                {(code === 'GENERAL_HUB_UNLOAD' || code === 'GENERAL_HUB_LOAD') &&
                  <span className="text_color_green">{"In Transit"}</span>
                }
                {code === 'IN_TRANSIT' && getMappingMessage != 'In Transit' &&
                  <span className="text_color_green">{"In Transit"}</span>
                }
                {code === 'OUTFORDELIVERY' && getMappingMessage != 'Out For Delivery' &&
                  <span className="text_color_green">{"Out For Delivery"}</span>
                }
                {(code === 'GENERAL_OPEN_LOAD' || code === 'LOAD') &&
                  <span className="text_color_green">{"Loaded"}</span>
                }
                {(code === 'GENERAL_DRIVER_UNLOAD' || code == 'UNLOAD') &&
                  <span className="text_color_green">{"In Warehouse"}</span>
                }
                {code === 'DELIVERY_CARDED' &&
                  <span className="text_color_green">{"Carded"}</span>
                }
                {code === 'EXCEPTION' &&
                  <span className="text_color_green">{"Booked"}</span>
                }
                {code === 'DELIVERYSUCCESS' && getMappingMessage != 'Delivered' &&
                  <span className="text_color_green">{"Delivered"}</span>
                }
                {code === 'DELAYED' && getMappingMessage != 'DELAYED' &&
                  <span className="text_color_green">{"Delayed"}</span>
                }
              </div><div className="Sub_center_columns">
                <div className="form_id">
                  <div className="track_inner">
                    <div className="trck_id_L">
                      <label>Tracking Number</label>
                      <input type="text" name="Tracking Number" value={trackingNumber}
                        onChange={(e) => dispatch(setTrackingNum(e.target.value))} readOnly={isReadOnly} />
                    </div>
                    {/* BR-1920: shown on the home page too — an order number needs the postcode to be found. */}
                    <div className="trck_id_C">
                      <label>Postcode / phone last 4</label>
                      <input type="text" name="More Information" placeholder="Optional — shows full details" value={postCode}
                        onChange={(e) => dispatch(setUserPostCode(e.target.value))} readOnly={isReadOnly} />
                    </div>
                  </div>
                  {shipmentStatus != true &&
                    <div className="trck_id_R">
                      <div className="position_bootom">
                        <button type="button" data-bs-target="#Verify" data-bs-toggle="modal" onClick={TrackingData}>Track</button>
                      </div>
                    </div>
                  }
                  {/* BR-1920: one branch for every company (was a company 19299 special case). The driver
                      position is blank unless the API sent the full record, so no extra gate is needed here. */}
                  {loc.pathname !== '/' &&
                    shipmentStatus === true && (
                      <div className="newtrack_S">
                        <div className="newtrack_bootom">
                          <button
                            type="button"
                            data-bs-target="#Verify"
                            data-bs-toggle="modal"
                            onClick={tracks}
                          >
                            New Track
                          </button>
                          <span className="trackdriver_info">
                            {/* BR-1929: was hidden whenever Out For Delivery - the moment it matters. Only skip it when the
                                inline driver map in TrackProgress is already showing (OFD + verified + internal job). */}
                            {!(cstatus === "Out For Delivery" && (fullAccess || hasToken) && isInternal == 1) &&
                              driverlat.length !== 0 &&
                              driverlong.length !== 0 && (
                                <>
                                  <Button onClick={location}>Track Driver</Button>
                                  <DriverLocationComponent
                                    visibles={isDialogOpen}
                                    setVisibles={closeDialog}
                                  />
                                </>
                              )}
                          </span>
                        </div>
                      </div>
                    )}

                </div>
                {podFatherPod && (
                  <div className="restricted_note podfather_pod" style={{ marginTop: 8, fontSize: 14 }}>
                    Proof of delivery for {podFatherPod.jobid}:{' '}
                    <a href={podFatherPod.path} target="_blank" rel="noopener noreferrer"><b>Download POD</b></a>
                  </div>
                )}
                {loc.pathname !== '/' && trackingStatus === 'success' && !fullAccess && !hasToken && (
                  <div className="restricted_note" style={{ marginTop: 8, fontSize: 14 }}>
                    Showing delivery progress only. To see the address, delivery photos and driver details, enter
                    the delivery postcode or the last 4 digits of the phone number and press Track.
                  </div>
                )}
              </div>

              <div className="topSub_columns destop_hide">
                <div className="Sub_left_columns">
                  <span className="text_color_black">ORDER</span>
                  {cstatus == '' &&
                    <span className="text_color_green">DETAIL</span>
                  }
                  {
                    <span className="text_color_green">{getMappingMessage}</span>
                    // :    
                    // <span className="text_color_green">{cstatus}</span> 

                  }
                  {(code === 'GENERAL_HUB_UNLOAD' || code === 'GENERAL_HUB_LOAD') &&
                    <span className="text_color_green">{"In Transit"}</span>
                  }
                  {code === 'IN_TRANSIT' && getMappingMessage != 'In Transit' &&
                    <span className="text_color_green">{"In Transit"}</span>
                  }
                  {code === 'OUTFORDELIVERY' && getMappingMessage != 'Out For Delivery' &&
                    <span className="text_color_green">{"Out For Delivery"}</span>
                  }
                  {(code === 'GENERAL_OPEN_LOAD' || code === 'LOAD') &&
                    <span className="text_color_green">{"Loaded"}</span>
                  }
                  {(code === 'GENERAL_DRIVER_UNLOAD' || code == 'UNLOAD') &&
                    <span className="text_color_green">{"In Warehouse"}</span>
                  }
                  {code === 'DELIVERY_CARDED' &&
                    <span className="text_color_green">{"Carded"}</span>
                  }
                  {code === 'EXCEPTION' &&
                    <span className="text_color_green">{"Booked"}</span>
                  }
                  {code === 'DELIVERYSUCCESS' && getMappingMessage != 'Delivered' &&
                    <span className="text_color_green">{"Delivered"}</span>
                  }
                  {code === 'DELAYED' && getMappingMessage != 'DELAYED' &&
                    <span className="text_color_green">{"Delayed"}</span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
